import React, { useEffect, useState } from 'react';
import { CoreUser } from '@eb/context-gen';
import { getUserCollections as getUserCollectionsApi } from '../api';
import { Collection } from '../types';

interface CoreUserWithCollections extends CoreUser {
    collections: {
        userCollections: Collection[] | [];
        setUserCollections: Function;
    };
}

interface UserProviderProps {
    user: CoreUser;
}

export const UserContext = React.createContext<
    Partial<CoreUserWithCollections>
>({});

export const UserProvider: React.FunctionComponent<UserProviderProps> = (
    props,
) => {
    const [userCollections, setUserCollections] = useState([]);

    useEffect(() => {
        if (props.user.isAuthenticated) {
            const getUserCollections = async () => {
                const { collections } = await getUserCollectionsApi(
                    props.user.publicId,
                );
                setUserCollections(collections);
            };

            getUserCollections();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <UserContext.Provider
            value={{
                ...props.user,
                collections: { userCollections, setUserCollections },
            }}
        >
            {props.children}
        </UserContext.Provider>
    );
};
